import Tags from '../Tags'

const TagsInput = ({ value, onChange, hasError }) => {
  const handleTagCreate = (tag) => {
    onChange([...value, tag])
  }

  const handleTagRemove = (tag) => {
    const newTags = value.filter((t) => t.value !== tag.value)
    onChange(newTags)
  }

  return (
    <div className='tag-input-modal'>
      <Tags
        className={hasError ? 'react-select-error' : ''}
        value={value}
        creatable
        onCreate={handleTagCreate}
        onRemove={handleTagRemove}
      />
    </div>
  )
}

export default TagsInput
